"use strict";

angular.module("passwordStrengthValidator")
.component("passwordStrengthValidator", {
    templateUrl: require("./password-strength-validator.component.html"),
    css: [require("./password-strength-validator.useable.scss")],
    bindings: {
        passwordModel: "=",
        label: "@",
        isFormSubmitted: "<",
        form: "=",
        inputName: "@",
        otherUserInputs: "<?",
        optional: "<?",
        isDisabled: "<?"
    },
    controller: "PasswordStrengthValidatorCtrl"
})
.controller("PasswordStrengthValidatorCtrl", function($scope) {
    var _this = this;
    $scope.minLength = 8;
    $scope.maxLength = 50;
    $scope.score = null;
    $scope.passwordStrength = {};

    this.hasCustomErrors = function(formElement) {
        var pwd = _this.passwordModel || "";
        return (
            formElement.$error.minLength ||
            formElement.$error.maxLength ||
            formElement.$error.containsOneDigit ||
            formElement.$error.containsOneUppercase ||
            formElement.$error.containsOneLowercase
        ) && pwd.length !== 0
    };

    this.computeScore = function(password, userInputs) {
        var compute = zxcvbn(password, userInputs);
        return compute && compute.score;
    };

    this.setupFormGroupClass = function() {
        if (!this.form  || !this.form.hasOwnProperty(this.inputName)) {
            return {};
        }

        var formElement = this.form[this.inputName];
        var hasCustomErrors = this.hasCustomErrors(formElement);
        return {
            "has-error": this.isFormSubmitted && (formElement.$error.required || hasCustomErrors),
            "has-warning": hasCustomErrors && formElement.$dirty
        }
    };

    this.onChange = function() {
        $scope.$evalAsync(function($scope) {
            var pwd = _this.passwordModel || "";
            var name = _this.inputName;

            if (pwd.length <= $scope.maxLength) {
                $scope.score = pwd ? (pwd.length >= $scope.minLength && _this.computeScore(pwd, _this.otherUserInputs) || 0) : null;
            }

            var formField = _this.form[name];
            if (formField) {
                formField.$setValidity("minLength", pwd.length >= $scope.minLength || pwd.length === 0);
                formField.$setValidity("maxLength", pwd.length <= $scope.maxLength || pwd.length === 0);
                formField.$setValidity("containsOneDigit", !!pwd.match(/\d/) || pwd.length === 0);
                formField.$setValidity("containsOneUppercase", !!pwd.match(/[A-Z]/) || pwd.length === 0);
                formField.$setValidity("containsOneLowercase", !!pwd.match(/[a-z]/) || pwd.length === 0);
            }
        });
    };

    $scope.$watch("$ctrl.otherUserInputs", this.onChange);

})
.filter("passwordLength", function() {
    return function(value, peak) {
        value = angular.isString(value) ? value : "";
        peak = isFinite(peak) ? peak : $scope.minLength;
        return value && (value.length > peak ? peak + "+" : value.length);
    };
});



//////////////////
// WEBPACK FOOTER
// ./core/password-strength-validator/password-strength-validator.component.js
// module id = 330
// module chunks = 0